import { DevelopmentType } from "@gql/sites-api/graphql";

const PROJECT_GRADIENT_MAP: Record<DevelopmentType, string> = {
  [DevelopmentType.Residential]: "bg-gradient-to-b from-green-500 to-green-600",
  [DevelopmentType.Commercial]: "bg-gradient-to-b from-[#77A5F6] to-platform-blue-600",
  [DevelopmentType.MixedUse]: "bg-gradient-to-b from-amber-200 to-amber-500",
  [DevelopmentType.StudentHousing]: "bg-gradient-to-b from-[#717182] to-[#A0ACBC]",
  [DevelopmentType.Power]: "bg-gradient-to-b from-amber-200 to-amber-500",
  [DevelopmentType.Retirement]: "bg-gradient-to-b from-amber-500 to-red-600",
  [DevelopmentType.Industrial]: "bg-gradient-to-b from-[#717182] to-[#A0ACBC]",
  [DevelopmentType.Other]: "bg-gradient-to-b from-platform-blue-600 to-[#A342FF]",
};

export function getDevelopmentTypeGradientClass(developmentType: DevelopmentType): string {
  const gradientClass = PROJECT_GRADIENT_MAP[developmentType as DevelopmentType];
  return gradientClass || PROJECT_GRADIENT_MAP[DevelopmentType.Other];
}
